export default __webpack_public_path__ + "static/media/6_3.bb40d518.jpg";